import { HTMLProps, useState } from "react";
import { makeStyles, createStyles, Theme, SvgIcon, fade } from "@material-ui/core";
import { useCopyToClipboard } from "react-use";

import { Copy } from "~components/Icons";
import { Tooltip } from "~components/Tooltip";

export type ClipboardCopyProps = {
  children: string | number;
} & HTMLProps<HTMLDivElement>;

export const ClipboardCopy = ({ children, ...props }: ClipboardCopyProps) => {
  const classes = useStyles();
  const [, copyToClipboard] = useCopyToClipboard();
  const [tooltipOpen, setTooltipOpen] = useState(false);

  return (
    <Tooltip
      PopperProps={{ disablePortal: true }}
      onClose={() => setTooltipOpen(false)}
      placement="right-end"
      open={tooltipOpen}
      disableFocusListener
      disableHoverListener
      disableTouchListener
      title="Copied!"
      arrow={undefined}
    >
      <div
        className={classes.root}
        onClick={() => {
          copyToClipboard(String(children));
          setTooltipOpen(true);
          setTimeout(() => setTooltipOpen(false), 1000);
        }}
        role="button"
        {...props}
      >
        {children}
        <SvgIcon component={Copy} color="primary" className={classes.copy} viewBox="0 0 12 12" />
      </div>
    </Tooltip>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      cursor: "pointer",
      display: "inline-flex",
      alignItems: "center",
      padding: `0px ${theme.spacing(0.5)}px`,
      margin: `0px -${theme.spacing(0.5)}px`,
      "&:hover": {
        backgroundColor: fade(theme.palette.text.primary, theme.palette.action.hoverOpacity),
        borderRadius: theme.shape.borderRadius,
      },
    },
    copy: {
      fontSize: 16,
      marginLeft: 4,
    },
  }),
);
